import PageNotices from "./PageNotices";
import TopNav from "./TopNav";

type LayoutProps = {
  children: React.ReactNode;
  user: {
    email: string;
  };
  errors?: string[];
  notice?: string;
};

export default function AuthenticatedLayout({ children, user, errors, notice }: LayoutProps) {
  return (
    <>
      <TopNav user={user} />

      <main className="container mx-auto mb-16">
        <PageNotices errors={errors} notice={notice} />
        <div>{children}</div>
      </main>
    </>
  );
}
